import { type RouteRecordRaw } from "vue-router";

import { APP_AGENT_ROUTES as AGENT } from "@/Generated/Routes/paths";

export default [
  {
    path: AGENT.root.path,
    components: {
      main: () => import("@/Views/agent/index.vue"),
      sidebar: () => import("@/Components/layout/SidebarLayout.vue"),
    },
    meta: {
      sidebar: true,
      drawer: false,
    },
    children: [
      {
        ...AGENT.root,
        component: () => import("@/Views/agent/Contacts.vue"),
        meta: {
          noHeader: true,
        },
      },
    ],
  },
] as RouteRecordRaw[];
